import { useState } from "react";
import { AppBar, Box, Tab, Tabs, Typography } from "@mui/material";
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ComplaintHistory from "./ComplaintHistory";
import ComplaintNote from "./ComplaintNote";
import ComplaintSummary from "./ComplaintSummary";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (<div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
    >
        {value === index && (
            <Box p={3}>
                <Typography>{children}</Typography>
            </Box>
        )}
    </div>);
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

const ComplaintTab = ({ complaintData, setComplaintData, setLoading, setSnackbarMsg, setSnackbarOpen }) => {
    const classes = useStyles();
    const [tabValue, setTabValue] = useState(0);


    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    }

    return (<div className={classes.root}>
        <AppBar position="static">
            <Tabs
                value={tabValue}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant="scrollable"
                scrollButtons="auto"
            >
                <Tab label="Summary" {...a11yProps(0)} />
                <Tab label="Comments" {...a11yProps(1)} />
                <Tab label="History" {...a11yProps(2)} />
            </Tabs>
        </AppBar>

        <TabPanel value={tabValue} index={0}>
            <ComplaintSummary complaintData={complaintData} setComplaintData={setComplaintData.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
            <ComplaintNote complaintData={complaintData} setComplaintData={setComplaintData.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
            <ComplaintHistory complaintData={complaintData} />
        </TabPanel>
    </div>);
}

export default ComplaintTab;